import React from "react";
import cn from "classnames";

import './style.css'

function DotLive({className}) {
  return (
    <span className={cn('live-dot', className)} aria-label="Идёт игра" title="Идёт игра">
      <span className="live-dot__pulse" aria-hidden="true"></span>
      <span className="live-dot__core" aria-hidden="true"></span>
    </span>
  )
}

export default DotLive